export default [
  "maternity",
  "mother",
  "mom",
  "pregnant",
  "pregnancy",
  "breastfeeding",
];
